import {
  COL_FILTER_HEADER_ACCOUNT,
  COL_FILTER_HEADER_CHILD_ENTITLEMENT,
  COL_FILTER_HEADER_ENTITLEMENT,
  COL_FILTER_HEADER_ROLE,
  COL_FILTER_HEADER_USER,
} from '../../../../ViewControls';

import {
  TAB_CHILDREN,
  TAB_DEPENDENT,
  TAB_ENTITLEMENT,
  TAB_HISTORY,
  TAB_PRIVILEGE,
  TAB_SOD,
  TAB_SUMMARY,
} from './constant';

export const textWhenNoDataTextForSidePanel = (tab) => {
  switch (tab) {
    case TAB_HISTORY:
      return 'No actions or comments have been recorded for this certification yet.';
    case TAB_SUMMARY:
      return "There's no summary available for this user.";
    default:
      return '';
  }
};

export const textWhenNoDataErrorForSidePanel = (tab) => {
  switch (tab) {
    case TAB_HISTORY:
      return "The History tab didn't load properly due to a network issue. Please refresh or try again later.";
    case TAB_SUMMARY:
      return "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.";
    case TAB_SOD:
      return "The Access Conflicts tab didn't load properly due to a network issue. Please refresh or try again later.";
    case TAB_PRIVILEGE:
      return "The Privilege tab didn't load properly due to a network issue. Please refresh or try again later.";
    case TAB_CHILDREN:
      return "The Child Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.";
    case TAB_DEPENDENT:
      return "The Dependent Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.";
    case TAB_ENTITLEMENT:
      return "The Child Roles tab didn't load properly due to a network issue. Please refresh or try again later.";
    default:
      return '';
  }
};

export const getFilteredNodeData = (obj, mapper) => {
  const filteredObj = {};

  // Determine category based on CERT_ENTITLEMENT_VALUEKEY
  let category;

  if (obj.CERT_ENTITLEMENT_VALUEKEY === '0') {
    category = COL_FILTER_HEADER_ACCOUNT;
  } else if (parseInt(obj.CERT_ENTITLEMENT_VALUEKEY, 10) > 0) {
    category = COL_FILTER_HEADER_ENTITLEMENT;
  } else if (obj.CERT_ENTITLEMENT_VALUEKEY === '-4') {
    category = COL_FILTER_HEADER_USER;
  } else if (obj.CERT_ENTITLEMENT_VALUEKEY === '-2') {
    category = COL_FILTER_HEADER_ROLE;
  }

  if (category) {
    const allowedAttributes = mapper[category];

    if (!allowedAttributes) return filteredObj;

    Object.keys(allowedAttributes)?.forEach((attr) => {
      const realAttr = attr;

      if (Object.prototype.hasOwnProperty.call(obj, realAttr)) {
        filteredObj[realAttr] = obj[realAttr];
      }
    });
  }

  return filteredObj;
};

export const getEOCampaignFilteredNodeData = (obj, mapper) => {
  const filteredObj = {};

  // Determine category based on CERT_ENTITLEMENT_VALUEKEY
  let category;

  if (obj.CERT_ENTITLEMENT_VALUEKEY === '1') {
    category = COL_FILTER_HEADER_ACCOUNT;
  } else if (obj.CERT_ENTITLEMENT_VALUEKEY === '0') {
    category = COL_FILTER_HEADER_ENTITLEMENT;
  } else if (obj.CERT_ENTITLEMENT_VALUEKEY === '-1') {
    category = COL_FILTER_HEADER_CHILD_ENTITLEMENT;
  }

  if (category) {
    const allowedAttributes = mapper[category];

    if (!allowedAttributes) return filteredObj;

    Object.keys(allowedAttributes)?.forEach((attr) => {
      const realAttr = attr;

      if (Object.prototype.hasOwnProperty.call(obj, realAttr)) {
        filteredObj[realAttr] = obj[realAttr];
      }
    });
  }

  return filteredObj;
};

export const shouldShowArsButton = (data) => {
  if (data?.CERT_ENTITLEMENT_VALUEKEY !== '-4' && data?.arstaskkeyflag) {
    return true;
  }

  return false;
};
